<ng-container *transloco="let t">
  <div class="drawer lg:drawer-open h-screen">
    <input class="drawer-toggle" id="my-drawer-2" type="checkbox" />

    <!-- SIDEBAR -->
    <div class="drawer-side z-1000">
      <label class="drawer-overlay" for="my-drawer-2"></label>

      <aside class="bg-neutral text-base-content w-80 flex flex-col h-full fixed lg:static top-0 left-0 z-50">
        <!-- 1) Top section: Logo/title -->
        <div
          (click)="onLogoClicked()"
          (keydown.enter)="onLogoClicked()"
          (keydown.space)="onLogoClicked()"
          class="flex flex-row items-center p-5 gap-4 pb-12 pl-14"
          tabindex="0"
        >
          <div class="cursor-pointer inline-flex items-center gap-4">
            <img alt="Österreich Flagge - Startseite" class="h-5" src="icon_at.svg" />
            <h2 class="text-2xl">{{ t("common.ibdatenbank") }}</h2>
          </div>
        </div>

        <app-input-search-dropdown-uif
          (selection)="onSearchSelection($event)"
          [items]="filterItems()"
          class="pb-10"
        ></app-input-search-dropdown-uif>
        <!-- 2) Middle section: scrollable menu -->
        <div class="flex-1 overflow-y-auto overflow-x-clip">
          <ul class="menu w-full">
            @for (item of navService.globalItems(); track $index) {
              <li app-shell-navitem-uif [globalItem]="true" [navDto]="item"></li>
            }
          </ul>
        </div>

        <!-- Bottom: Favoriten und Bottom-Items -->
        <div class="border-t-2 border-t-primary mt-auto">
          <ul class="menu w-full">
            @for (item of navService.bottomItems(); track $index) {
              <li app-shell-navitem-uif [globalItem]="true" [navDto]="item"></li>
            }
          </ul>
        </div>
      </aside>
    </div>
    <div class="drawer-content flex flex-col h-full overflow-hidden">
      <!-- MOBILE MENU BUTTON -->
      <div class="lg:hidden w-full p-4 shadow-sm">
        <label class="btn join-item btn-ghost drawer-button" for="my-drawer-2">
          <i-lucide [img]="hamburgerIcon" size="30"></i-lucide>
          <span class="sr-only">{{ t("shell.sidebar.open") }}</span>
        </label>
      </div>
      <!-- MAIN CONTENT -->
      <div class="h-screen grid grid-rows-[4rem_1fr_3.6rem]">
        <!-- Row 1: Header -->
        <div class="bg-primary p-2 text-white">
          <app-shell-breadcrumbs-uif #breadcrumbs />
        </div>

        <!-- Row 2: Main area (scrollable content + fixed infobox + action bar) -->
        <div class="flex flex-col overflow-hidden">
          <!-- Scrollable main content -->
          <main #main class="flex-1 overflow-y-auto" id="main" tabindex="-1">
            @if (shellService.hasPageCriticalError()) {
              <app-page-error-uif [pageErrorTypeOverride]="'unknown'" />
            } @else if (shellService.hasPagePermissionError()) {
              <app-page-error-uif [pageErrorTypeOverride]="'permission-denied'" />
            } @else if (!shellService.isPageCriticalLoading()) {
              <app-form-blocker-uif
                (clicked)="timemachineClicked()"
                [blocKInput]="false"
                [description]="
                  'Zeitmaschine ist aktiv! Aktuelles Datum: ' +
                  (sessionService.sessionInfoQuery.data()?.currentUtc | date: 'dd.MM.yyyy')
                "
                [onDisabled]="timeMachineActive()"
                [useAlert]="true"
                messageTitle="Achtung"
                type="warning"
              >
                <ng-content></ng-content>
              </app-form-blocker-uif>
            }

            <div [classList]="shellService.isPageCriticalLoading() ? '' : 'hidden'">
              <ng-container #skeletonContainer></ng-container>
            </div>
          </main>

          <!-- Action-Bar (fixed, part of shell) -->
          <div [style.padding-right.px]="scrollbarWidth()">
            <div class="z-50 bg-white py-4 lg:container mx-auto px-6 flex flex-col gap-4">
              <!-- Infobox Display (fixed, part of shell) -->
              @if (
                !shellService.hasPageCriticalError() &&
                !shellService.hasPagePermissionError() &&
                !shellService.isPageCriticalLoading()
              ) {
                <app-infobox-display-uif />
              }
              @if (actionButtons().length > 0 || shellService.showPagination()) {
                @if (shellService.showPagination()) {
                  <app-pagination-uif
                    (paginationChange)="onPaginationChange($event)"
                    [pageSize]="shellService.pagination().pageSize"
                    [page]="shellService.pagination().page"
                    [totalRows]="shellService.totalRowCount()"
                    class="w-full"
                  >
                    <div class="flex justify-end gap-4">
                      @for (button of actionButtonsToRender(); track button.id) {
                        <app-button-uif
                          (clicked)="executeAction(button.id)"
                          [customConfirmText]="button.customConfirmText || undefined"
                          [delete_enabled]="button.deleteShortcut || false"
                          [disabled]="button.disabled || false"
                          [iconLeft]="button.icon"
                          [label]="button.label"
                          [loading]="button.loading || false"
                          [requireConfirmation]="button.requireConfirmation || false"
                          [strg_s_enabled]="button.saveShortcut || false"
                          [variant]="button.variant || 'default'"
                        ></app-button-uif>
                      }
                    </div>
                  </app-pagination-uif>
                } @else {
                  <div class="flex justify-end gap-4">
                    @for (button of actionButtonsToRender(); track button.id) {
                      <app-button-uif
                        (clicked)="executeAction(button.id)"
                        [customConfirmText]="button.customConfirmText || undefined"
                        [delete_enabled]="button.deleteShortcut || false"
                        [disabled]="button.disabled || false"
                        [iconLeft]="button.icon"
                        [label]="button.label"
                        [loading]="button.loading || false"
                        [requireConfirmation]="button.requireConfirmation || false"
                        [strg_s_enabled]="button.saveShortcut || false"
                        [variant]="button.variant || 'default'"
                      ></app-button-uif>
                    }
                  </div>
                }
              }
            </div>
          </div>
        </div>

        <!-- Row 3: Footer -->
        <app-footer-uif />
      </div>
      <!-- /MAIN CONTENT -->
    </div>
  </div>
</ng-container>
